import {combineReducers} from 'redux';
import Settings from './Setting';
import Common from './Common';
import GoldReserve, {GoldReserveState} from './GoldReserve';
import Buyback, {BuybackState} from './Buyback';
import PriceIncrease, {PriceIncreaseState} from './PriceIncrease';
import Auth, {AuthState} from './Auth';
import Web3, {Web3State} from './Web3';
import {Setting} from '../../types/models/Setting';
import {Common as CommonState} from '../../types/models/Common';
import ExchangeRate, {ExchangeRateState} from './ExchangeRate';
import TokenStatus, {TokenStatusState} from './Token/Pause';
import TokenEmissions, {TokenEmissionsState} from './Token/Emissions';
import Admin, {AdminState} from './Admin';
import BackendWallets, {BackendWalletsState} from './BackendWallets';
import FreeMetaTransactions, {
  FreeMetaTransactionsState,
} from './FreeMetaTransactions';
import Exchanges, {ExchangesState} from './Exchanges/Exchanges';
import PriceCorrectionLogs, {
  PriceCorrectionLogsState,
} from './PriceCorrectionLogs';
import ExchangeStatus, {ExchangeStatusState} from './Exchanges/ExchangeStatus';
import Transaction, {TransactionState} from './Transaction';
import Notifications, {NotificationsState} from './Notifications';
import Reports, {ReportsState} from './Exchanges/Reports';
import OpenOrders, {OpenOrdersState} from './Exchanges/OpenOrders';
import EmissionBackingEstimate, {
  EmissionBackingEstimateState,
} from './Token/EmissionBackingEstimate';
import Fees, {FeesState} from './Fees';
import SpecialWallets, {SpecialWalletsState} from './SpecialWallets';
export interface IState {
  settings: Setting;
  auth: AuthState;
  common: CommonState;
  web3: Web3State;
  goldReserve: GoldReserveState;
  buyback: BuybackState;
  priceIncrease: PriceIncreaseState;
  exchangeRate: ExchangeRateState;
  token: {
    status: TokenStatusState;
    emissions: TokenEmissionsState;
  };
  admin: AdminState;
  backendWallets: BackendWalletsState;
  freeMetaTransactions: FreeMetaTransactionsState;
  exchanges: ExchangesState;
  priceCorrectionLogs: PriceCorrectionLogsState;
  exchangeStatus: ExchangeStatusState;
  transactions: TransactionState;
  reports: ReportsState;
  openOrders: OpenOrdersState;
  notifications: NotificationsState;
  emissionBackingEstimate: EmissionBackingEstimateState;
  fees: FeesState;
  specialWallets: SpecialWalletsState;
}

const reducers = {
  settings: Settings,
  auth: Auth,
  common: Common,
  web3: Web3,
  goldReserve: GoldReserve,
  buyback: Buyback,
  priceIncrease: PriceIncrease,
  exchangeRate: ExchangeRate,
  token: combineReducers({
    status: TokenStatus,
    emissions: TokenEmissions,
  }),
  admin: Admin,
  backendWallets: BackendWallets,
  freeMetaTransactions: FreeMetaTransactions,
  exchanges: Exchanges,
  priceCorrectionLogs: PriceCorrectionLogs,
  exchangeStatus: ExchangeStatus,
  transactions: Transaction,
  notifications: Notifications,
  reports: Reports,
  openOrders: OpenOrders,
  emissionBackingEstimate: EmissionBackingEstimate,
  fees: Fees,
  specialWallets: SpecialWallets,
};

export default reducers;
